import { render, staticRenderFns } from "./histogramCourse.vue?vue&type=template&id=243c5a8c&scoped=true"
import script from "./histogramCourse.vue?vue&type=script&lang=js"
export * from "./histogramCourse.vue?vue&type=script&lang=js"
import style0 from "./histogramCourse.vue?vue&type=style&index=0&id=243c5a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243c5a8c",
  null
  
)

export default component.exports